/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import { Transition } from "@headlessui/react";
import { Accordion, AccordionBody, AccordionHeader, Avatar, Button, Menu, MenuHandler, MenuItem, MenuList, Typography } from "@material-tailwind/react";
import { Link } from 'react-router-dom';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/solid';
import Cookies from 'js-cookie';


function NavbarCommon() {
  const [isOpen, setIsOpen] = useState(false);
  const [open, setOpen] = useState(0);

  const handleOpen = (value) => setOpen(open === value ? 0 : value);

  const [isLogin, setIsLogin] = useState(false)

  useEffect(() => {
    const userToken = Cookies.get('userToken')
    const userRole = Cookies.get('userRole')

    if (userToken && userRole) {
      setIsLogin(true)
    }
  }, [])

  return (
    <div className='sticky top-0 z-50'>
      <nav className="bg-white border-b-2">

        {/* when screen desktop */}
        <div className="m-auto px-7 md:px-11">
          <div className="flex items-center justify-between h-16">

            {/* logo and menu */}
            <div className="flex items-center">

              <div className="shrink">
                <Link to="/">
                  <img
                    className="w-32 md:w-28"
                    src="LogoLanscape.png"
                    alt="Logo Real Job Portal"
                  />
                </Link>
              </div>


              <div className="hidden md:flex shrink justify-between">
                {/* menu when desktop*/}
                <div className="ml-5 flex items-baseline space-x-5">
                  <Link to='/loker'>
                    <Typography variant='small' className='font-bold hover:underline hover:underline-offset-8 hover:text-blue-gray-700'>Lowongan Kerja</Typography>
                  </Link>

                  <Menu placement='bottom-start'>
                    <MenuHandler>
                      <Typography variant='small' className='font-bold hover:underline hover:underline-offset-8 hover:text-blue-gray-700 cursor-pointer '>Program</Typography>
                    </MenuHandler>
                    <MenuList>
                      <MenuItem>Persiapan Interview</MenuItem>
                      <MenuItem>Bootcamp</MenuItem>
                      <MenuItem>Internship</MenuItem>
                    </MenuList>
                  </Menu>

                  <Link to='/'>
                    <Typography variant='small' className='font-bold hover:underline hover:underline-offset-8 hover:text-blue-gray-700'>Event</Typography>
                  </Link>
                </div>
              </div>

            </div>

            {/* button log in out*/}
            <div className='hidden md:flex items-center gap-4 '>

              {isLogin ? (
                // avatar display after login succes
                <div className="flex items-center gap-1">
                  {Cookies.get('userRole') === 'admin' ? (
                    <Link to='/dashboard'>
                      <Avatar size="sm" withBorder={true} src="https://docs.material-tailwind.com/img/face-2.jpg" alt="avatar" />
                    </Link>
                  ) : (
                    <Avatar size="sm" withBorder={true} src="https://docs.material-tailwind.com/img/face-2.jpg" alt="avatar" />
                  )}
                  <Typography variant="h6">{Cookies.get('userRole')}</Typography>
                </div>
              ) : (
                <>
                  <Link to='/login'><Button size="sm" variant="outlined">Masuk</Button></Link>
                  <Link to='/register'><Button size="sm" >Registasi</Button></Link>
                </>
              )}





            </div>

            {/* button burger */}
            <div className="flex md:hidden gap-4">
              {isLogin ? (
                // avatar display after login succes
                <>
                  <div className="flex items-center gap-1">
                    {Cookies.get('userRole') === 'admin' ? (
                      <Link to='/dashboard'>
                        <Avatar size="sm" withBorder={true} src="https://docs.material-tailwind.com/img/face-2.jpg" alt="avatar" />
                      </Link>
                    ) : (
                      <Avatar size="sm" withBorder={true} src="https://docs.material-tailwind.com/img/face-2.jpg" alt="avatar" />
                    )}
                    <Typography variant="h6">{Cookies.get('userRole')}</Typography>
                  </div>
                  <button
                    onClick={() => setIsOpen(!isOpen)}
                    className="bg-black flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white"
                  >
                    {!isOpen ? (
                      <Bars3Icon className="block h-6 w-6" />
                    ) : (
                      <XMarkIcon className="block h-6 w-6" />
                    )}
                  </button>

                </>

              ) : (
                <>
                  <button
                    onClick={() => setIsOpen(!isOpen)}
                    className="bg-black flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white"
                  >
                    {!isOpen ? (
                      <Bars3Icon className="block h-6 w-6" />
                    ) : (
                      <XMarkIcon className="block h-6 w-6" />
                    )}
                  </button>
                </>
              )}

            </div>
          </div>
        </div>

        {/* menu when burger click on screen mobile */}
        <Transition
          show={isOpen}
          enter="transition ease-out duration-100 transform"
          enterFrom="opacity-0 scale-95"
          enterTo="opacity-100 scale-100"
          leave="transition ease-in duration-75 transform"
          leaveFrom="opacity-100 scale-100"
          leaveTo="opacity-0 scale-95"
        >
          {(ref) => (
            <div className="w-full absolute bg-white border-b-2 md:hidden" id="mobile-menu">

              {/* menu when mobile*/}
              <div ref={ref} className="px-7 pt-3 pb-10 space-y-1">
                <div className='flex justify-center gap-6 p-3 border-1 mb-5'>
                  <Link to='/login'><Button size="sm" variant="outlined">Masuk</Button></Link>
                  <Link to='/register'><Button size="sm" >Registasi</Button></Link>
                </div>

                {/* <Accordion>
                  <AccordionHeader>Lowongan Kerja</AccordionHeader>
                </Accordion> */}
                <Link to='/loker'>
                  <Typography variant='small' className='font-bold hover:underline hover:underline-offset-8 hover:text-blue-gray-700'>Lowongan Kerja</Typography>
                </Link>

                <Accordion open={open === 1} className='pb-2'>
                  <AccordionHeader onClick={() => handleOpen(1)}>
                    <Typography variant='small' className='font-bold hover:underline hover:underline-offset-8'>Program</Typography>
                  </AccordionHeader>
                  <AccordionBody className='space-y-1'>
                    <Typography variant='small' className='ml-5 hover:bg-gray-100 py-1 px-2 rounded'>Persiapan Interview</Typography>
                    <Typography variant='small' className='ml-5 hover:bg-gray-100 py-1 px-2 rounded'>Bootcamp</Typography>
                    <Typography variant='small' className='ml-5 hover:bg-gray-100 py-1 px-2 rounded'>Internship</Typography>
                  </AccordionBody>
                </Accordion>

                <Link to='/'>
                  <Typography variant='small' className='font-bold hover:underline hover:underline-offset-8 hover:text-blue-gray-700'>Event</Typography>
                </Link>
              </div>
            </div>
          )}
        </Transition>
      </nav >
    </div >
  )
}

export default NavbarCommon;